import * as React from 'react';

import { ReactComponent as DefaultLogo } from './assets/logo.svg';
import { ReactComponent as MonochromeLogo } from './assets/logo-mono.svg';
import { ReactComponent as LettersLogo } from './assets/logo-letters.svg';
import catsLogo from './assets/logo-cats.image.svg';
// import celebrationLogo from './assets/logo-celebration.image.svg';
import mobileLogo from './assets/logo-mobile.image.svg';
import rocketLogo from './assets/logo-rocket.image.svg';
import skeletonsLogo from './assets/logo-skeletons.image.svg';
import surfLogo from './assets/logo-surf.image.svg';

export const EASTER_LOGOS = {
  cats: catsLogo,
  // celebration: celebrationLogo,
  mobile: mobileLogo,
  rocket: rocketLogo,
  skeletons: skeletonsLogo,
  surf: surfLogo,
};

const COLOR_LOGOS = {
  default: DefaultLogo,
  monochrome: MonochromeLogo,
  letters: LettersLogo,
  ...EASTER_LOGOS,
};

export const EASTER_LOGOS_LIST = Object.keys(EASTER_LOGOS);
export interface Props extends React.HTMLAttributes<HTMLImageElement> {
  type?: (keyof typeof COLOR_LOGOS)[number];
}

export const CompanyLogo = ({ type, ...restProps }: Props) => {
  // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  const Logo = COLOR_LOGOS[type];
  if (type && ['monochrome', 'default', 'letters'].includes(type)) {
    return <Logo aria-hidden {...restProps} />;
  }

  return (
    <img
      src={Logo}
      alt="Evil Martians logo"
      aria-hidden
      loading="lazy"
      {...restProps}
    />
  );
};
